import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class CheckMarginUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.checkMargin(req);
    }
}
export default CheckMarginUseCase;
